import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/uiconfig';
import { useLanguage, useTranslator } from '@jutro/locale';
import { displayLanguageFormattedDate } from 'gw-capability-fnol-adac-react';
import metadata from './CommunicationHistory.metadata.json5';
import messages from './CommunicationHistory.messages';
import styles from './CommunicationHistory.module.scss';

function CommunicationHistory(props) {
    const { dataToDisplay, filtersToBeShown } = props;
    const language = useLanguage().language;
    const [typeFilterValue, setTypeFilterValue] = useState("ALL");
    const [sourceFilterValue, setSourceFilterValue] = useState("ALL");
    const translator = useTranslator();

    const renderDateCell = useCallback((value) => {
        return displayLanguageFormattedDate(value.date, language);
    }, [])

    const renderFromColumn = useCallback((value) => {
        if (value.entrySource === "ADAC") {
            return translator(messages.fromColumnADAC);
        }

        return translator(messages.fromColumnMember);
    }, [])

    const renderHistoryTypeColumn = useCallback((value) => {
        switch(value.entryType) {
            case "MESSAGE":
                return translator(messages.typeColumnMessage);
            case "DOCUMENT":
                return translator(messages.typeColumnDocument);
            case "CALLBACK_REQUEST":
                return translator(messages.typeColumnCallback);
            case "CLAIM_CREATION":
                return translator(messages.typeColumnClaimCreation);
            default:
                return "";
        }
    }, []);

    const renderTextAreaCell = useCallback((value, index) => {
        var content = value.entryType !== "CLAIM_CREATION" 
            ? value.content
            : translator(messages.typeColumnClaimCreation);

        return (
            <div id={`content${index}`} className={styles.scrollableDiv}>
                {content}           
            </div>
        )
    })

    const filterEntriesToDisplay = useCallback(() => {
        let valuesToBeReturned = dataToDisplay;

        if (valuesToBeReturned === undefined || _.isEmpty(valuesToBeReturned)) {
            return [];
        }

        if (typeFilterValue !== "ALL") {
            valuesToBeReturned = valuesToBeReturned.filter((entry) => entry.entryType == typeFilterValue);
        }

        if (sourceFilterValue !== "ALL") {
            valuesToBeReturned = valuesToBeReturned.filter((entry) => entry.entrySource == sourceFilterValue);
        }

        return valuesToBeReturned;
    }, [typeFilterValue, dataToDisplay, sourceFilterValue])

    const overrides = {
        historyEntries: {
            data: filterEntriesToDisplay(dataToDisplay)
        },
        typeFilter: {
            visible: filtersToBeShown.indexOf('type') !== -1,
            value: typeFilterValue,
            onValueChange: (value) => setTypeFilterValue(value),
            availableValues: [
                {
                  "code": "MESSAGE",
                  "name": translator(messages.filtersTypeMesssage)
                },
                {
                  "code": 'DOCUMENT',
                  "name": translator(messages.filtersTypeDocuments)
                },
                {
                  "code": 'CALLBACK_REQUEST',
                  "name": translator(messages.filtersTypeCallbackRequest)
                },
                {
                  "code": 'ALL',
                  "name": translator(messages.filtersTypeShowAll)
                }
              ]
        },
        sourceFilter: {
            visible: filtersToBeShown.indexOf('from') !== -1,
            value: sourceFilterValue,
            onValueChange: (value) => setSourceFilterValue(value),
            availableValues: [
                {
                  "code": "ADAC",
                  "name": translator(messages.fromColumnADAC)
                },
                {
                  "code": 'MEMBER',
                  "name": translator(messages.fromColumnMember)
                },
                {
                  "code": 'ALL',
                  "name": translator(messages.filtersTypeShowAll)
                }
              ]
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
            renderDateCell,
            renderFromColumn,
            renderHistoryTypeColumn,
            renderTextAreaCell
        }
    };
    return <MetadataContent
        uiProps={metadata.componentContent}
        overrideProps={overrides}
        {...resolvers}
    />;
}

export default withRouter(CommunicationHistory);
